import { ArrowPathIcon, SignalSlashIcon } from '@heroicons/react/24/outline';

import { ConnectivityWindow } from '../../../services/models/assets';

const formatDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

const formatDuration = (minutes: number): string => {
  const d = Math.floor(minutes / 1440);
  const h = Math.floor((minutes % 1440) / 60);
  const m = minutes % 60;
  if (d > 0) return `${d}j ${h}h`;
  if (h > 0) return `${h}h ${m}min`;
  return `${m}min`;
};

interface Props {
  windows?: ConnectivityWindow[];
  isLoading: boolean;
}

const ConnectivityTimeline: React.FC<Props> = ({ windows, isLoading }) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-card outline outline-1 outline-offset-[-1px] outline-neutral-10 flex flex-col gap-4">
      <h3 className="text-neutral typo-h3">Déconnexions</h3>
      {isLoading ? (
        <span className="text-neutral-40 typo-small">Chargement...</span>
      ) : !windows || windows.length === 0 ? (
        <span className="text-neutral-40 typo-small">Aucune déconnexion détectée sur la période sélectionnée.</span>
      ) : (
        <ul className="flex flex-col gap-2 max-h-80 overflow-y-auto pr-1">
          {[...windows].reverse().map((w, index) => (
            <li
              key={`${w.downFrom}-${index}`}
              className="flex items-center gap-3 px-3 py-2 rounded-md bg-off-white"
            >
              <SignalSlashIcon className={`w-5 h-5 shrink-0 ${w.ongoing ? 'text-error-600' : 'text-neutral-40'}`} />
              <div className="flex flex-col flex-1 min-w-0">
                <span className="text-neutral typo-small">
                  {formatDateTime(w.downFrom)}
                  {w.downTo ? ` → ${formatDateTime(w.downTo)}` : ' → en cours'}
                </span>
                <span className="text-neutral-40 typo-caption">
                  {formatDuration(w.durationMinutes)}
                  {w.ongoing ? ' · station hors ligne' : ''}
                </span>
              </div>
              {w.likelyReboot && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-100 text-primary-500 typo-caption shrink-0">
                  <ArrowPathIcon className="w-3.5 h-3.5" />
                  Redémarrage
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ConnectivityTimeline;
